// src/cms.ts
var SUBSCRIPTION_ACTION_UPDATE_LOCK = "UPDATE_LOCK";
var DATABASE_SCHEMA_CHANGED = "DATABASE_SCHEMA_CHANGED";
var STATUS_REQUEST = "STATUS_REQUEST";
var STATUS_ERROR = "STATUS_ERROR";
var STATUS_SUCCESS = "STATUS_SUCCESS";
var ARTICLE_UPDATED = "ARTICLE_UPDATED";
var BOARD_UPDATED = "BOARD_UPDATED";
var SORT_PUBL_DESC = "PUBLICATION_DATE_DESC";
var SORT_PUBL_ASC = "PUBLICATION_DATE_ASC";
var SORT_EDITED_DESC = "LAST_EDITED_DESC";
var SORT_EDITED_ASC = "LAST_EDITED_ASC";
var LS_UPDATE_LOCKSTATUS = "LS_UPDATE_LOCKSTATUS";
var LS_READ_ONLY_MODE = "LS_READ_ONLY_MODE";
var LS_LOCK_DIALOG_OTHER_AUTHOR = "LS_LOCK_DIALOG_OTHER_AUTHOR";
var LS_LOCK_DIALOG_OUTDATED_VERSION = "LS_LOCK_DIALOG_OUTDATED_VERSION";
var LS_LOCK_DIALOG_BROKEN_BY_USER = "LS_LOCK_DIALOG_BROKEN_BY_USER";
var LS_LOCK_DIALOG_UPDATED_WHILE_LOCK = "LS_LOCK_DIALOG_UPDATED_WHILE_LOCK";
var LS_UPDATE_LOCKED_ITEMS = "LS_UPDATE_LOCKED_ITEMS";
var LS_REMOVE_LOCKED_ITEM = "LS_REMOVE_LOCKED_ITEM";
var LS_RESET_LOCKED_ITEMS = "LS_RESET_LOCKED_ITEMS";
var TYPE_ARTICLE = "ARTICLE";
var TYPE_BOARD = "BOARD";
var TYPE_BOARD_TEASER = "BOARD_TEASER";
var TYPE_AUTHOR = "AUTHOR";
var GENDER_MALE = "MALE";
var GENDER_FEMALE = "FEMALE";
var CREATOR_UPDATE = "creator/CREATOR_UPDATE";
var CREATOR_RESET = "creator/CREATOR_RESET";
var USER_SETTINGS_UPDATE = "USER_SETTINGS_UPDATE";
var USER_ADD_FLAG = "USER_ADD_FLAG";
var USER_DELETE_FLAG = "USER_DELETE_FLAG";
var USER_SECTION_UPDATE_FLAG = "USER_SECTION_UPDATE_FLAG";
var USER_SECTION_AUTOFILL_FLAG = "USER_SECTION_AUTOFILL_FLAG";
var SOPHORA_SEARCH_UPDATE = "SOPHORA_SEARCH_UPDATE";
var SOPHORA_SEARCH_FIRE = "SOPHORA_SEARCH_FIRE";
var SOPHORA_FETCH = "SOPHORA_FETCH";
var BOARD_BUFFER_VALIDATE = "BOARD_BUFFER_VALIDATE";
var BOARD_BUFFER_INITIALIZE = "BOARD_BUFFER_INITIALIZE";
var BOARD_BUFFER_INITIALIZE_AND_CLEAN = "BOARD_BUFFER_INITIALIZE_AND_CLEAN";
var BOARD_BUFFER_CLEAN = "BOARD_BUFFER_CLEAN";
var BOARD_BUFFER_UPDATE = "BOARD_BUFFER_UPDATE";
var BOARD_BUFFER_ERROR = "BOARD_BUFFER_ERROR";
var BOARD_BUFFER_SOCIAL_MEDIA_ADD = "BOARD_BUFFER_SOCIAL_MEDIA_ADD";
var BOARD_BUFFER_SOCIAL_MEDIA_UPDATE = "BOARD_BUFFER_SOCIAL_MEDIA_UPDATE";
var BOARD_BUFFER_SOCIAL_MEDIA_DELETE = "BOARD_BUFFER_SOCIAL_MEDIA_DELETE";
var BOARD_BUFFER_SECTION_ADD = "BOARD_BUFFER_SECTION_ADD";
var BOARD_BUFFER_SECTION_UPDATE = "BOARD_BUFFER_SECTION_UPDATE";
var BOARD_BUFFER_SECTION_DELETE = "BOARD_BUFFER_SECTION_DELETE";
var BOARD_BUFFER_SECTION_ORDER = "BOARD_BUFFER_SECTION_ORDER";
var BOARD_BUFFER_SECTION_REBUILD_ORDER = "BOARD_BUFFER_SECTION_REBUILD_ORDER";
var BOARD_BUFFER_SECTION_ITEM_ADD = "BOARD_BUFFER_SECTION_ITEM_ADD";
var BOARD_BUFFER_SECTION_ITEM_UPDATE = "BOARD_BUFFER_SECTION_ITEM_UPDATE";
var BOARD_BUFFER_SECTION_ITEM_DELETE = "BOARD_BUFFER_SECTION_ITEM_DELETE";
var BOARD_BUFFER_SECTION_ITEM_ORDER = "BOARD_BUFFER_SECTION_ITEM_ORDER";
var BOARD_BUFFER_PERSIST = "BOARD_BUFFER_PERSIST";
var ARTICLE_BUFFER_CLEAN = "ARTICLE_BUFFER_CLEAN";
var ARTICLE_BUFFER_INITIALIZE = "ARTICLE_BUFFER_INITIALIZE";
var ARTICLE_BUFFER_MODULE_ADD = "ARTICLE_BUFFER_MODULE_ADD";
var ARTICLE_BUFFER_MODULE_DELETE = "ARTICLE_BUFFER_MODULE_DELETE";
var ARTICLE_BUFFER_MODULE_UPDATE = "ARTICLE_BUFFER_MODULE_UPDATE";
var ARTICLE_BUFFER_UPDATE = "ARTICLE_BUFFER_UPDATE";
var ARTICLE_BUFFER_UPDATE_TAGS = "ARTICLE_BUFFER_UPDATE_TAGS";
var BOARDS_TEASER_BUFFER_INITIALIZE = "BOARDS_TEASER_BUFFER_INITIALIZE";
var BOARDS_TEASER_BUFFER_UPDATE = "BOARDS_TEASER_BUFFER_UPDATE";
var BOARDS_TEASER_BUFFER_CLEAN = "BOARDS_TEASER_BUFFER_CLEAN";
var AM_UPDATE = "AM_UPDATE";
var AM_SET = "AM_SET";
var AM_TEMPLATE_SELECT = "AM_TEMPLATE_SELECT";
var AM_TEMPLATE_ADD = "AM_TEMPLATE_ADD";
var AM_TEMPLATE_DELETE = "AM_TEMPLATE_DELETE";
var AM_UPDATE_SELECTION = "AM_UPDATE_SELECTION";
var AUTHORS_MANAGER_UPDATE_FILTER = "AUTHORS_MANAGER_UPDATE_FILTER";
var CLEAR_MATERIAL_BROWSER = "CLEAR_MATERIAL_BROWSER";
var ADD_MATERIAL = "ADD_MATERIAL";
var DELETE_MATERIAL = "DELETE_MATERIAL";
var APP_INITIALIZE = "APP_INITIALIZE";
var APP_BREAKPOINT_UPDATE = "APP_BREAKPOINT_UPDATE";
var BP_XS = "(max-width: 930px)";
var BP_S = "(min-width: 931px) and (max-width: 1200px)";
var BP_M = "(min-width: 1201px) and (max-width: 1400px)";
var BP_L = "(min-width: 1401px)";
var BP_ALL = [BP_XS, BP_S, BP_M, BP_L];
var LOGIN_ACTION = "auth/LOGIN";
var LOGOUT_ACTION = "auth/LOGOUT";
var BRBILD_LOGIN = "brbild/BRBILD_LOGIN";
var STATUS_DRAFT = "DRAFT";
var STATUS_REVIEW = "REVIEW";
var STATUS_SCHEDULED = "SCHEDULED";
var STATUS_DEPUBLISHED = "DEPUBLISHED";
var STATUS_PUBLISHED = "PUBLISHED";
var STATUS_DELETED = "DELETED";
var STATUS_CHANGED = "CHANGED";
var STATUS_CHANGE_PUBLICATION_DATE = "CHANGE_PUBLICATION_DATE";
var STATUS_CANNOT_PLACE = "CANNOT_PLACE";
var STATUS_NOT_WHITELISTED = "NOT_WHITELISTED";
var STATUS_ALREADY_ON_THE_LIST = "ALREADY_ON_THE_LIST";
var STATUS_ALL = [
  STATUS_DRAFT,
  STATUS_REVIEW,
  STATUS_SCHEDULED,
  STATUS_DEPUBLISHED,
  STATUS_PUBLISHED,
  STATUS_DELETED,
  STATUS_CHANGED,
  STATUS_CHANGE_PUBLICATION_DATE,
  STATUS_CANNOT_PLACE,
  STATUS_NOT_WHITELISTED,
  STATUS_ALREADY_ON_THE_LIST
];
var CATEGORY_ALL = "CATEGORY_ALL";
var CAPABILITY_FULLY_FEATURED = "FULLY_FEATURED";
var CAPABILITY_BASIC = "BASIC";
var CAPABILITY_TEXT_ONLY = "TEXT_ONLY";
var CAPABILITY_ALL = [
  CAPABILITY_FULLY_FEATURED,
  CAPABILITY_BASIC,
  CAPABILITY_TEXT_ONLY
];
var PRIORITY_CRITICAL = "CRITICAL";
var PRIORITY_HIGH = "HIGH";
var PRIORITY_NORMAL = "NORMAL";
var PRIORITY_LOW = "LOW";
var PRIORITY_ALL = [
  PRIORITY_LOW,
  PRIORITY_NORMAL,
  PRIORITY_HIGH,
  PRIORITY_CRITICAL
];
var MODULE_TYPE_GALLERY = "GALLERY";
var MODULE_TYPE_EMBED = "EMBED";
var MODULE_TYPE_TEXT = "TEXT";
var MODULE_TYPE_AUDIO = "AUDIO";
var MODULE_TYPE_VIDEO = "VIDEO";
var MODULE_TYPE_IMAGE = "IMAGE";
var MODULE_TYPE_VIDEO360 = "VIDEO360";
var MODULE_TYPE_LIVESTREAM = "LIVESTREAM";
var MODULE_ALL = [
  MODULE_TYPE_TEXT,
  MODULE_TYPE_IMAGE,
  MODULE_TYPE_GALLERY,
  MODULE_TYPE_VIDEO,
  MODULE_TYPE_AUDIO,
  MODULE_TYPE_EMBED,
  MODULE_TYPE_VIDEO360,
  MODULE_TYPE_LIVESTREAM
];
var EMBED_TYPE_CIVEY = "civey";
var EMBED_TYPE_EBU = "ebu";
var EMBED_TYPE_FACEBOOK = "facebook";
var EMBED_TYPE_OPINARY = "opinary";
var EMBED_TYPE_SCRIBBLE = "scribble";
var EMBED_TYPE_TABLEAU = "tableau";
var EMBED_TYPE_TWITTER = "twitter";
var EMBED_TYPE_FACTFOX = "factfox";
var EMBED_TYPE_INSTAGRAM = "instagram";
var EMBED_TYPE_CUSTOM_BR24 = "custom-br24";
var EMBED_TYPE_CUSTOM_BRDATA = "custom-br-data";
var LOCATION_DISTRICT = "district";
var LOCATION_ZIPCODE = "zipCode";
var LOCATION_STREET = "street";
var LOCATION_STREETNUMBER = "streetNumber";
var LOCATION_COUNTRY = "country";
var LOCATION_STATE = "state";
var LOCATION_CITY = "city";
var LOCATION_SUBURB = "suburb";
var DISTRICT_MITTELFRANKEN = "MITTELFRANKEN";
var DISTRICT_OBERFRANKEN = "OBERFRANKEN";
var DISTRICT_UNTERFRANKEN = "UNTERFRANKEN";
var DISTRICT_NIEDERBAYERN = "NIEDERBAYERN";
var DISTRICT_OBERPFALZ = "OBERPFALZ";
var DISTRICT_SCHWABEN = "SCHWABEN";
var DISTRICT_OBERBAYERN = "OBERBAYERN";
var DISTRICTS_ALL = [
  DISTRICT_MITTELFRANKEN,
  DISTRICT_OBERFRANKEN,
  DISTRICT_UNTERFRANKEN,
  DISTRICT_NIEDERBAYERN,
  DISTRICT_OBERPFALZ,
  DISTRICT_SCHWABEN,
  DISTRICT_OBERBAYERN
];
var TAG_STATUS_ACTIVE = "ACTIVE";
var TAG_STATUS_RECOMMENDED = "RECOMMENDED";
var TAG_STATUS_SUPERSEDED = "SUPERSEDED";
var TAG_STATUS_SPECIAL = "SPECIAL";
var TAG_STATUS_ALL = [
  TAG_STATUS_ACTIVE,
  TAG_STATUS_RECOMMENDED,
  TAG_STATUS_SUPERSEDED,
  TAG_STATUS_SPECIAL
];
var PUSH_NOTIFICATION_NONE = "NONE";
var PUSH_NOTIFICATION_SILENT = "SILENT";
var PUSH_NOTIFICATION_SOUND = "SOUND";
var PUSH_NOTIFICATION_ALL = [
  PUSH_NOTIFICATION_NONE,
  PUSH_NOTIFICATION_SILENT,
  PUSH_NOTIFICATION_SOUND
];
var VIDEO_RESOLUTION_LOW = "HLS_LOW";
var VIDEO_RESOLUTION_HIGH = "HLS_HIGH";
var VIDEO_RESOLUTION_HD = "FULL_HD";
var VIDEO_RESOLUTION_UHD = "UHD";
var VIDEO_RESOLUTION_ALL = [
  VIDEO_RESOLUTION_LOW,
  VIDEO_RESOLUTION_HIGH,
  VIDEO_RESOLUTION_HD,
  VIDEO_RESOLUTION_UHD
];
var COLOR_BOARD_SECTION_1 = "#D20DE2";
var COLOR_BOARD_SECTION_2 = "#A6A6A6";
var COLOR_BOARD_SECTION_3 = "#4D4D4D";
var COLOR_BOARD_SECTION_4 = "#7D7D7D";
var COLOR_BOARD_SECTION_ALL = [
  COLOR_BOARD_SECTION_1,
  COLOR_BOARD_SECTION_2,
  COLOR_BOARD_SECTION_3,
  COLOR_BOARD_SECTION_4
];
var COLOR_TURQUOISE = "#1abc9c";
var COLOR_GREEN_SEA = "#16a085";
var COLOR_EMERALD = "#2ecc71";
var COLOR_NEPHRITIS = "#27ae60";
var COLOR_BR24 = "#0B9FD8";
var COLOR_PETER_RIVER = "#3498db";
var COLOR_BELIZE_HOLE = "#2980b9";
var COLOR_AMETHYST = "#9b59b6";
var COLOR_WISTERIA = "#8e44ad";
var COLOR_WET_ASPHALT = "#34495e";
var COLOR_MIDNIGHT_BLUE = "#2c3e50";
var COLOR_SUN_FLOWER = "#f1c40f";
var COLOR_ORANGE = "#f39c12";
var COLOR_CARROT = "#e67e22";
var COLOR_PUMPKIN = "#d35400";
var COLOR_ALIZARIN = "#e74c3c";
var COLOR_POMEGRANATE = "#c0392b";
var COLOR_SILVER = "#bdc3c7";
var COLOR_CONCRETE = "#95a5a6";
var COLOR_ASBESTOS = "#7f8c8d";
var COLOR_ALL = [
  COLOR_TURQUOISE,
  COLOR_GREEN_SEA,
  COLOR_EMERALD,
  COLOR_NEPHRITIS,
  COLOR_BR24,
  COLOR_PETER_RIVER,
  COLOR_BELIZE_HOLE,
  COLOR_AMETHYST,
  COLOR_WISTERIA,
  COLOR_WET_ASPHALT,
  COLOR_MIDNIGHT_BLUE,
  COLOR_SUN_FLOWER,
  COLOR_ORANGE,
  COLOR_CARROT,
  COLOR_PUMPKIN,
  COLOR_ALIZARIN,
  COLOR_POMEGRANATE,
  COLOR_SILVER,
  COLOR_CONCRETE,
  COLOR_ASBESTOS
];
var STAGE_TYPE_NONE = "NONE";
var STAGE_TYPE_SIDE_BY_SIDE = "SIDE_BY_SIDE";
var STAGE_TYPE_CAROUSEL = "CAROUSEL";
var DND_BOARD_ARTICLE = "DND_BOARD_ARTICLE";
var DND_MODULE_GALLERY_IMAGE = "DND_MODULE_GALLERY_IMAGE";
var DND_BOARD_ITEM = "DND_BOARD_ITEM";
var DND_BOARD_SECTION = "DND_BOARD_SECTION";
var SOCIAL_MEDIA_ACCOUNT_EMAIL = "EMAIL";
var SOCIAL_MEDIA_ACCOUNT_FACEBOOK_PAGE = "FACEBOOK_PAGE";
var SOCIAL_MEDIA_ACCOUNT_TWITTER = "TWITTER";
var SOCIAL_MEDIA_ACCOUNT_INSTAGRAM = "INSTAGRAM";
var SOCIAL_MEDIA_ACCOUNT_YOUTUBE = "YOUTUBE";
var SOCIAL_MEDIA_ACCOUNT_SPOTIFY = "SPOTIFY";
var SOCIAL_MEDIA_ACCOUNT_ALL = [
  SOCIAL_MEDIA_ACCOUNT_EMAIL,
  SOCIAL_MEDIA_ACCOUNT_FACEBOOK_PAGE,
  SOCIAL_MEDIA_ACCOUNT_TWITTER,
  SOCIAL_MEDIA_ACCOUNT_INSTAGRAM,
  SOCIAL_MEDIA_ACCOUNT_YOUTUBE,
  SOCIAL_MEDIA_ACCOUNT_SPOTIFY
];
var LOCALLY_CREATED_ID = "LOCALLY_CREATED_ID";
var SECTION_THEME_LIGHT = "LIGHT";
var SECTION_THEME_DARK = "DARK";
var SECTION_ADDON_BAYERNKARTE = "BAYERNKARTE";
var SECTION_ADDON_RUNDSCHAU_100_SEKUNDEN = "RUNDSCHAU_100_SEKUNDEN";
var SECTION_ADDON_B5_NACHRICHTEN = "B5_NACHRICHTEN";
var SECTION_ADDON_B5_BOERSE = "B5_BOERSE";
var SECTION_ADDON_NONE = "NONE_ADDON";
var SECTION_ADDON_ALL = [
  SECTION_ADDON_NONE,
  SECTION_ADDON_BAYERNKARTE,
  SECTION_ADDON_RUNDSCHAU_100_SEKUNDEN,
  SECTION_ADDON_B5_NACHRICHTEN,
  SECTION_ADDON_B5_BOERSE
];
var FLAG_WELCOME_MODAL_SEEN = "WELCOME_MODAL_SEEN";
var SECTION_SCHEMA_STAGE_CAROUSEL = "STAGE_CAROUSEL";
var SECTION_SCHEMA_STAGE_SPLITTED = "STAGE_SPLITTED";
var SECTION_SCHEMA_SMALL_3 = "SMALL_3";
var SECTION_SCHEMA_RAISED_LEFT_SIMPLE = "RAISED_LEFT_SIMPLE";
var SECTION_SCHEMA_RAISED_RIGHT_SIMPLE = "RAISED_RIGHT_SIMPLE";
var SECTION_SCHEMA_REGIONAL_4_SIMPLE = "REGIONAL_4_SIMPLE";
var SECTION_SCHEMA_REGIONAL_2_BIG_TOP = "REGIONAL_2_BIG_TOP";
var SECTION_SCHEMA_REGIONAL_1_BIG_TOP_2_SMALL_BELOW = "REGIONAL_1_BIG_TOP_2_SMALL_BELOW";
var SECTION_SCHEMA_REGIONAL_2_SMALL_TOP_1_BIG_BELOW = "REGIONAL_2_SMALL_TOP_1_BIG_BELOW";
var SECTION_SCHEMA_HIGHLIGHT_3 = "HIGHLIGHT_3";
var SECTION_SCHEMA_CATEGORY_LEFT_2_SMALL = "CATEGORY_LEFT_2_SMALL";
var SECTION_SCHEMA_CATEGORY_LEFT_1_BIG = "CATEGORY_LEFT_1_BIG";
var SECTION_SCHEMA_CATEGORY_RIGHT_2_SMALL = "CATEGORY_RIGHT_2_SMALL";
var SECTION_SCHEMA_CATEGORY_RIGHT_1_BIG = "CATEGORY_RIGHT_1_BIG";
var SECTION_SCHEMA_RAISED_RIGHT_SHORTNEWS = "RAISED_RIGHT_SHORTNEWS";
var SECTION_SCHEMA_RAISED_RIGHT_SHORTNEWS_2_SMALL = "RAISED_RIGHT_SHORTNEWS_2_SMALL";
var SECTION_SCHEMA_RAISED_RIGHT_SIMPLE_WEATHER = "RAISED_RIGHT_SIMPLE_WEATHER";
var SECTION_SCHEMA_SUBJECTS_NEWS_WEATHER = "SUBJECTS_NEWS_WEATHER";
var SECTION_SCHEMA_ALL = [
  SECTION_SCHEMA_STAGE_CAROUSEL,
  SECTION_SCHEMA_SMALL_3,
  SECTION_SCHEMA_RAISED_LEFT_SIMPLE,
  SECTION_SCHEMA_RAISED_RIGHT_SIMPLE,
  SECTION_SCHEMA_REGIONAL_4_SIMPLE,
  SECTION_SCHEMA_REGIONAL_2_BIG_TOP,
  SECTION_SCHEMA_REGIONAL_1_BIG_TOP_2_SMALL_BELOW,
  SECTION_SCHEMA_REGIONAL_2_SMALL_TOP_1_BIG_BELOW,
  SECTION_SCHEMA_HIGHLIGHT_3,
  SECTION_SCHEMA_CATEGORY_LEFT_2_SMALL,
  SECTION_SCHEMA_CATEGORY_LEFT_1_BIG,
  SECTION_SCHEMA_CATEGORY_RIGHT_2_SMALL,
  SECTION_SCHEMA_CATEGORY_RIGHT_1_BIG,
  SECTION_SCHEMA_RAISED_RIGHT_SHORTNEWS,
  SECTION_SCHEMA_RAISED_RIGHT_SHORTNEWS_2_SMALL,
  SECTION_SCHEMA_RAISED_RIGHT_SIMPLE_WEATHER,
  SECTION_SCHEMA_SUBJECTS_NEWS_WEATHER
];
var EXPIRATION_EPG_BUSINESS_CONTENT = "EPG_BUSINESS_CONTENT";
var EXPIRATION_REPEATED_EVENTS = "REPEATED_EVENTS";
var EXPIRATION_SUPPORTING_INFO = "SUPPORTING_INFO";
var EXPIRATION_SERIES = "SERIES";
var EXPIRATION_EDUCATION = "EDUCATION";
var EXPIRATION_TIME_CULTURE = "TIME_CULTURE";
var EXPIRATION_ALL = [
  {
    id: EXPIRATION_EPG_BUSINESS_CONTENT,
    duration: Infinity,
    units: "years",
    required: false
  },
  {
    id: EXPIRATION_REPEATED_EVENTS,
    duration: Infinity,
    units: "years",
    required: true
  },
  {
    id: EXPIRATION_SUPPORTING_INFO,
    duration: 12,
    units: "months",
    required: true
  },
  {
    id: EXPIRATION_SERIES,
    duration: 12,
    units: "months",
    required: true
  },
  {
    id: EXPIRATION_EDUCATION,
    duration: 5,
    units: "years",
    required: true
  },
  {
    id: EXPIRATION_TIME_CULTURE,
    duration: Infinity,
    units: "years",
    required: false
  }
];
var LINKS_DOMAINS_WHITELIST = [
  "*.br.de",
  "*.tagesschau.de",
  "*.sportschau.de",
  "*.bayern3.de",
  "*.br-klassik.de",
  "*.br24.de",
  "*.br-dev.de",
  "*.br-staging.de",
  "*.ard.de",
  "*.ardalpha.de",
  "*.ardmediathek.de",
  "*.ardaudiothek.de"
];

export {
  SUBSCRIPTION_ACTION_UPDATE_LOCK,
  DATABASE_SCHEMA_CHANGED,
  STATUS_REQUEST,
  STATUS_ERROR,
  STATUS_SUCCESS,
  ARTICLE_UPDATED,
  BOARD_UPDATED,
  SORT_PUBL_DESC,
  SORT_PUBL_ASC,
  SORT_EDITED_DESC,
  SORT_EDITED_ASC,
  LS_UPDATE_LOCKSTATUS,
  LS_READ_ONLY_MODE,
  LS_LOCK_DIALOG_OTHER_AUTHOR,
  LS_LOCK_DIALOG_OUTDATED_VERSION,
  LS_LOCK_DIALOG_BROKEN_BY_USER,
  LS_LOCK_DIALOG_UPDATED_WHILE_LOCK,
  LS_UPDATE_LOCKED_ITEMS,
  LS_REMOVE_LOCKED_ITEM,
  LS_RESET_LOCKED_ITEMS,
  TYPE_ARTICLE,
  TYPE_BOARD,
  TYPE_BOARD_TEASER,
  TYPE_AUTHOR,
  GENDER_MALE,
  GENDER_FEMALE,
  CREATOR_UPDATE,
  CREATOR_RESET,
  USER_SETTINGS_UPDATE,
  USER_ADD_FLAG,
  USER_DELETE_FLAG,
  USER_SECTION_UPDATE_FLAG,
  USER_SECTION_AUTOFILL_FLAG,
  SOPHORA_SEARCH_UPDATE,
  SOPHORA_SEARCH_FIRE,
  SOPHORA_FETCH,
  BOARD_BUFFER_VALIDATE,
  BOARD_BUFFER_INITIALIZE,
  BOARD_BUFFER_INITIALIZE_AND_CLEAN,
  BOARD_BUFFER_CLEAN,
  BOARD_BUFFER_UPDATE,
  BOARD_BUFFER_ERROR,
  BOARD_BUFFER_SOCIAL_MEDIA_ADD,
  BOARD_BUFFER_SOCIAL_MEDIA_UPDATE,
  BOARD_BUFFER_SOCIAL_MEDIA_DELETE,
  BOARD_BUFFER_SECTION_ADD,
  BOARD_BUFFER_SECTION_UPDATE,
  BOARD_BUFFER_SECTION_DELETE,
  BOARD_BUFFER_SECTION_ORDER,
  BOARD_BUFFER_SECTION_REBUILD_ORDER,
  BOARD_BUFFER_SECTION_ITEM_ADD,
  BOARD_BUFFER_SECTION_ITEM_UPDATE,
  BOARD_BUFFER_SECTION_ITEM_DELETE,
  BOARD_BUFFER_SECTION_ITEM_ORDER,
  BOARD_BUFFER_PERSIST,
  ARTICLE_BUFFER_CLEAN,
  ARTICLE_BUFFER_INITIALIZE,
  ARTICLE_BUFFER_MODULE_ADD,
  ARTICLE_BUFFER_MODULE_DELETE,
  ARTICLE_BUFFER_MODULE_UPDATE,
  ARTICLE_BUFFER_UPDATE,
  ARTICLE_BUFFER_UPDATE_TAGS,
  BOARDS_TEASER_BUFFER_INITIALIZE,
  BOARDS_TEASER_BUFFER_UPDATE,
  BOARDS_TEASER_BUFFER_CLEAN,
  AM_UPDATE,
  AM_SET,
  AM_TEMPLATE_SELECT,
  AM_TEMPLATE_ADD,
  AM_TEMPLATE_DELETE,
  AM_UPDATE_SELECTION,
  AUTHORS_MANAGER_UPDATE_FILTER,
  CLEAR_MATERIAL_BROWSER,
  ADD_MATERIAL,
  DELETE_MATERIAL,
  APP_INITIALIZE,
  APP_BREAKPOINT_UPDATE,
  BP_XS,
  BP_S,
  BP_M,
  BP_L,
  BP_ALL,
  LOGIN_ACTION,
  LOGOUT_ACTION,
  BRBILD_LOGIN,
  STATUS_DRAFT,
  STATUS_REVIEW,
  STATUS_SCHEDULED,
  STATUS_DEPUBLISHED,
  STATUS_PUBLISHED,
  STATUS_DELETED,
  STATUS_CHANGED,
  STATUS_CHANGE_PUBLICATION_DATE,
  STATUS_CANNOT_PLACE,
  STATUS_NOT_WHITELISTED,
  STATUS_ALREADY_ON_THE_LIST,
  STATUS_ALL,
  CATEGORY_ALL,
  CAPABILITY_FULLY_FEATURED,
  CAPABILITY_BASIC,
  CAPABILITY_TEXT_ONLY,
  CAPABILITY_ALL,
  PRIORITY_CRITICAL,
  PRIORITY_HIGH,
  PRIORITY_NORMAL,
  PRIORITY_LOW,
  PRIORITY_ALL,
  MODULE_TYPE_GALLERY,
  MODULE_TYPE_EMBED,
  MODULE_TYPE_TEXT,
  MODULE_TYPE_AUDIO,
  MODULE_TYPE_VIDEO,
  MODULE_TYPE_IMAGE,
  MODULE_TYPE_VIDEO360,
  MODULE_TYPE_LIVESTREAM,
  MODULE_ALL,
  EMBED_TYPE_CIVEY,
  EMBED_TYPE_EBU,
  EMBED_TYPE_FACEBOOK,
  EMBED_TYPE_OPINARY,
  EMBED_TYPE_SCRIBBLE,
  EMBED_TYPE_TABLEAU,
  EMBED_TYPE_TWITTER,
  EMBED_TYPE_FACTFOX,
  EMBED_TYPE_INSTAGRAM,
  EMBED_TYPE_CUSTOM_BR24,
  EMBED_TYPE_CUSTOM_BRDATA,
  LOCATION_DISTRICT,
  LOCATION_ZIPCODE,
  LOCATION_STREET,
  LOCATION_STREETNUMBER,
  LOCATION_COUNTRY,
  LOCATION_STATE,
  LOCATION_CITY,
  LOCATION_SUBURB,
  DISTRICT_MITTELFRANKEN,
  DISTRICT_OBERFRANKEN,
  DISTRICT_UNTERFRANKEN,
  DISTRICT_NIEDERBAYERN,
  DISTRICT_OBERPFALZ,
  DISTRICT_SCHWABEN,
  DISTRICT_OBERBAYERN,
  DISTRICTS_ALL,
  TAG_STATUS_ACTIVE,
  TAG_STATUS_RECOMMENDED,
  TAG_STATUS_SUPERSEDED,
  TAG_STATUS_SPECIAL,
  TAG_STATUS_ALL,
  PUSH_NOTIFICATION_NONE,
  PUSH_NOTIFICATION_SILENT,
  PUSH_NOTIFICATION_SOUND,
  PUSH_NOTIFICATION_ALL,
  VIDEO_RESOLUTION_LOW,
  VIDEO_RESOLUTION_HIGH,
  VIDEO_RESOLUTION_HD,
  VIDEO_RESOLUTION_UHD,
  VIDEO_RESOLUTION_ALL,
  COLOR_BOARD_SECTION_1,
  COLOR_BOARD_SECTION_2,
  COLOR_BOARD_SECTION_3,
  COLOR_BOARD_SECTION_4,
  COLOR_BOARD_SECTION_ALL,
  COLOR_TURQUOISE,
  COLOR_GREEN_SEA,
  COLOR_EMERALD,
  COLOR_NEPHRITIS,
  COLOR_BR24,
  COLOR_PETER_RIVER,
  COLOR_BELIZE_HOLE,
  COLOR_AMETHYST,
  COLOR_WISTERIA,
  COLOR_WET_ASPHALT,
  COLOR_MIDNIGHT_BLUE,
  COLOR_SUN_FLOWER,
  COLOR_ORANGE,
  COLOR_CARROT,
  COLOR_PUMPKIN,
  COLOR_ALIZARIN,
  COLOR_POMEGRANATE,
  COLOR_SILVER,
  COLOR_CONCRETE,
  COLOR_ASBESTOS,
  COLOR_ALL,
  STAGE_TYPE_NONE,
  STAGE_TYPE_SIDE_BY_SIDE,
  STAGE_TYPE_CAROUSEL,
  DND_BOARD_ARTICLE,
  DND_MODULE_GALLERY_IMAGE,
  DND_BOARD_ITEM,
  DND_BOARD_SECTION,
  SOCIAL_MEDIA_ACCOUNT_EMAIL,
  SOCIAL_MEDIA_ACCOUNT_FACEBOOK_PAGE,
  SOCIAL_MEDIA_ACCOUNT_TWITTER,
  SOCIAL_MEDIA_ACCOUNT_INSTAGRAM,
  SOCIAL_MEDIA_ACCOUNT_YOUTUBE,
  SOCIAL_MEDIA_ACCOUNT_SPOTIFY,
  SOCIAL_MEDIA_ACCOUNT_ALL,
  LOCALLY_CREATED_ID,
  SECTION_THEME_LIGHT,
  SECTION_THEME_DARK,
  SECTION_ADDON_BAYERNKARTE,
  SECTION_ADDON_RUNDSCHAU_100_SEKUNDEN,
  SECTION_ADDON_B5_NACHRICHTEN,
  SECTION_ADDON_B5_BOERSE,
  SECTION_ADDON_NONE,
  SECTION_ADDON_ALL,
  FLAG_WELCOME_MODAL_SEEN,
  SECTION_SCHEMA_STAGE_CAROUSEL,
  SECTION_SCHEMA_STAGE_SPLITTED,
  SECTION_SCHEMA_SMALL_3,
  SECTION_SCHEMA_RAISED_LEFT_SIMPLE,
  SECTION_SCHEMA_RAISED_RIGHT_SIMPLE,
  SECTION_SCHEMA_REGIONAL_4_SIMPLE,
  SECTION_SCHEMA_REGIONAL_2_BIG_TOP,
  SECTION_SCHEMA_REGIONAL_1_BIG_TOP_2_SMALL_BELOW,
  SECTION_SCHEMA_REGIONAL_2_SMALL_TOP_1_BIG_BELOW,
  SECTION_SCHEMA_HIGHLIGHT_3,
  SECTION_SCHEMA_CATEGORY_LEFT_2_SMALL,
  SECTION_SCHEMA_CATEGORY_LEFT_1_BIG,
  SECTION_SCHEMA_CATEGORY_RIGHT_2_SMALL,
  SECTION_SCHEMA_CATEGORY_RIGHT_1_BIG,
  SECTION_SCHEMA_RAISED_RIGHT_SHORTNEWS,
  SECTION_SCHEMA_RAISED_RIGHT_SHORTNEWS_2_SMALL,
  SECTION_SCHEMA_RAISED_RIGHT_SIMPLE_WEATHER,
  SECTION_SCHEMA_SUBJECTS_NEWS_WEATHER,
  SECTION_SCHEMA_ALL,
  EXPIRATION_EPG_BUSINESS_CONTENT,
  EXPIRATION_REPEATED_EVENTS,
  EXPIRATION_SUPPORTING_INFO,
  EXPIRATION_SERIES,
  EXPIRATION_EDUCATION,
  EXPIRATION_TIME_CULTURE,
  EXPIRATION_ALL,
  LINKS_DOMAINS_WHITELIST
};
//# sourceMappingURL=chunk-NNZGJCJS.js.map